/**
 * Copyright (c) 2025-present, NDLA.
 *
 * This source code is licensed under the GPLv3 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// N.B! AUTOGENERATED FILE. DO NOT EDIT
// Source: RemixIcon
// License: Apache License 2.0
import type { JSX } from "react";
import { Icon, type Props } from "../Icon";
export const VolumeUpFill = (props: Props): JSX.Element => (
  <Icon fill="currentColor" viewBox="0 0 24 24" {...props}>
    <path d="M2 16h3.89l5.3 4.33a.5.5 0 0 0 .81-.39V4.06a.5.5 0 0 0-.82-.4L5.88 8H2a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1m21-4c0 3.3-1.45 6.25-3.74 8.26l-1.42-1.42a8.98 8.98 0 0 0 0-13.68l1.42-1.42A11 11 0 0 1 23 12m-5 0a6 6 0 0 0-2.29-4.71l-1.43 1.43a4 4 0 0 1 0 6.56l1.43 1.43A6 6 0 0 0 18 12" />
  </Icon>
);
